<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <form @submit.prevent="changePassword">
          <div class="container-fluid mt-5">
            <div class="col-sm-12">
              <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
                <div class="row">
                  <div class="col-md-12">
                    <vs-breadcrumb
                      align="left"
                      :items="
                  [
                    {title: 'You are here : '},
                     {
                    title: 'Dashboard',
                    url: '/#/dashboard/trainee/traineeDashboard',
                    active: false
                  },
                    {
                      title: 'Change Password',
                      url: '/#/dashboard/Trainee/postassessment',
                      active: true
                    }
                  ]"
                    ></vs-breadcrumb>
                    <!-- <div class="heading mt-3">
                      <h3 class="text-secondary">Change Password</h3>
                    </div> -->
                  </div>
                </div>
                <div class="form-row">
                  
                  <div class="col-sm-6 ">
                    <h6 class="sub-frm-title">Change Password</h6>
                    <b-card v-if="isForm" style="border: 1px dotted #07a7e14f;">
                      <div class="form-group">
                        <div class="row">
                          <div class="col-md-6 col-lg-12" style="margin-top:30px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="password"
                                v-model="password"
                                placeholder=" "
                                 autocomplete="off"
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">vpn_key</i>
                              </span>

                              <label class="lbl-label">
                                New Password
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                            </div>
                          </div>
                           <div class="col-md-6 col-lg-12" style="margin-top:30px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                type="password"
                                v-model="cPassword"
                                placeholder=" "
                                 autocomplete="off"
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">vpn_key</i>
                              </span>

                              <label class="lbl-label">
                                Confirm Password
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-12">
                            <!-- add button starts-->

                            <b-button type="submit" class="save-btn" variant="primary">Change Password</b-button>
                            <!-- add button ends -->
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </div>
                </div>
                <!-- save button starts-->
                <!-- <a href="#" class="save-btn btn btn-info">Save</a> -->
                <!-- <a href="#" class="btn btn-secondary float-right mr-2">Add New</a> -->

                <!-- save button ends -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
          


<script>
import Navbar from "./Navbar";
import MainSidebar from "./main-sidebar";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import Selectize from "vue2-selectize";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    password:"",
    cPassword:"",
    error: "",
    success: "",
    title: "",
    name: "",
    referenceId: "",
    contactno: "",
    organization: "",
    email: "",
    isSidebar: false,
    isForm: true,
    isEditForm: false,
    isFormData: false,
    realtion: "",
    designation: "",
    relationSettings: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Reference"
    },
    designationSettings: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Designation"
    },

    relationArr: [],
    designationArr: [],
    items: [],
    userId:'',
  }),
   mounted() {
      axios.defaults.headers['Authorization'] = localStorage.getItem('token');
      this.userId = JSON.parse(localStorage.getItem('currentUser')).id;
  },
  //

  components: {
    "app-navbar": Navbar,
    "app-main-sidebar": MainSidebar,
    Selectize
  },

  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    changePassword(e){
      e.preventDefault();
       this.inValid = [];
      if (this.password == '') {
        this.inValid.push("Enter Your New Password");
      }
      if (this.cPassword == '') {
        this.inValid.push("Enter Confirm/Repeat the new password");
      }
      if (this.password != this.cPassword) {
        this.inValid.push("New and Confirm Password not matched");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if(!this.inValid.length){
       axios
          .post(
            localStorage.getItem("BASE_PATH") + "/change-password",{
              userId : this.userId,
              password:this.password
            }
        ).then (async  response =>{
          if(response.data.success){
            this.$toasted.global.successMsg(response.data.success); 
            await axios.get(localStorage.getItem("BASE_PATH") +"/logout");
            await localStorage.clear();
            await this.$router.push("/");
          }
          else if(response.data.error){
            this.$toasted.global.errorMsg(response.data.error);
          }
        })
      }
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: 32px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.addnew-btn {
  font-size: 12px;
  box-shadow: none;
  border-color: #6c757d;
  background-color: #6c757d;
  float: right;
  margin: 10px 0px;
}
.save-btn {
  box-shadow: none;
  font-size: 12px;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 5px;
}
.delete-btn {
  font-size: 12px;
  box-shadow: none;
  /* border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61); */
  float: right;
  margin: 10px 0px 0px 5px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #ffffff;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}


/* Floating label css ends */

.display-table ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.display-table li {
  float: left;
  padding: 5px 5px;
}

.display-table li a {
  cursor: inherit;
  font-size: 14px;
  display: block;
  color: #747679;
  text-align: center;
  padding: 5px;
  text-decoration: none;
  background-color: #f1f1f1;
}
.tbl-head th {
  font-weight: 400 !important;
  color: rgba(7, 167, 225, 0.61);
}
.display-table {
  /* margin-bottom: 0px !important; */
  color: #8e8e8e;
}
.display-table th,
.display-table td {
  padding: 5px 10px !important;
  /* border: 1px dotted #07a7e14f; */
}
.add-btn {
  float: right;
  margin-bottom: 25px;
}
</style>

